// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__rCCvO","title":"Header_title__eFL0b","side":"Header_side__1JTK0"};